import styled, { createGlobalStyle } from 'styled-components';
import { QUALITY_MARK_ASPECT_RATIO, breakpoints } from 'config/config';
import { Carousel } from 'antd';

export const GlobalStyle = createGlobalStyle`
  @media only screen and (max-width: ${breakpoints.xs}px) {
    .buy-latvia-food {
      display: none;
    }
  }
`;

export const StyledCarousel = styled(Carousel)`
  flex-grow: 1;

  .carusel-banner-image {
    width: 100%;
  }

  .gallery-img-container {
    .ant-image {
      display: flex !important;
      height: ${(props) => (props.rootClassName === 'full' ? '80vh' : '100%;')};
    }
  }

  .gallery-img-container {
    position: relative;

    .product-qualitymarks {
      position: absolute;
      top: 16px;
      left: 20px;
      display: flex;
      gap: 4px;
      max-width: calc(100% - 40px);
      flex-wrap: wrap;

      .product-qualitymarks-image {
        height: 21px;
        width: auto;
        aspect-ratio: ${QUALITY_MARK_ASPECT_RATIO};
        overflow: hidden;

        .ant-image {
          width: 100%;
          height: 100%;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            vertical-align: inherit;
          }
        }
      }
    }
  }

  li.slick-active {
    img {
      border: 2px solid ${(props) => props.theme.white} !important;
    }
  }

  .slick-slide {
    display: flex !important;
    justify-content: center;

    .slick-active {
    }
  }

  .slick-slide > div {
    width: 100%;
    height: ${(props) => (props.rootClassName === 'full' ? '100%' : 'auto')};
  }

  .slick-slide img {
    height: ${(props) => (props.rootClassName === 'full' ? '100%' : 'auto')};
    object-fit: ${(props) =>
      props.rootClassName === 'full' ? 'contain' : 'cover'};
  }

  .slick-list {
    min-height: 30px;
  }

  .slick-dots {
    li {
      height: 4px;
      border-radius: 2px;
      background-color: ${({ theme }) => theme.slickDotBgColor};

      &.slick-active {
        background-color: ${({ theme }) => theme.bgColorHover};
      }
    }
  }

  .banner-image-wrapper {
    padding: 50px 0 50px 0;
  }

  .ant-image {
    width: ${(props) => (props.rootClassName === 'full' ? '100%' : 'auto')};
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .banner-image-wrapper {
      padding: 30px 0 30px 0;
    }
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .banner-image-wrapper {
      padding: 20px 0px 20px 0px;
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    &:last-child {
      margin: 0;
    }

    .banner-image-wrapper {
      padding: 20px 0 20px 0;

      a img {
        max-height: 250px;
        max-width: 373px;
        object-fit: cover;
        object-position: left;
      }
    }
  }
`;

export const StyledCustomPaging = styled('div')`
  position: relative;

  &.custom-dot {
    position: absolute;
    height: 20px;
    width: 50px;

    &.image-dots {
      height: 116px;
      width: 116px;
    }
  }
`;

export const StyledImage = styled('div')`
  position: relative;
  top: 25px;
  left: 0;
  max-width: 116px;
  max-height: 116px;
  object-fit: cover;
  border-radius: 4px;
`;

export const StyledAppendDotsContainer = styled('div')`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;
  margin-top: 20px;
`;

export const StyledAppendDotsInner = styled('div')`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 110px;
  align-items: center;

  li {
    width: 24px !important;
  }
`;
